// In-memory session token store.
//
// The JWT is intentionally NOT persisted to localStorage. Persistence across
// page reloads is handled by the backend's HttpOnly `access_token` cookie,
// which JavaScript — and therefore any XSS payload — cannot read. Keeping the
// token only in memory removes the exfiltratable target while still letting
// same-session requests attach an Authorization header for backward
// compatibility.
let inMemoryToken: string | null = null

export const setAuthToken = (token: string | null): void => {
  inMemoryToken = token
}

export const getAuthToken = (): string | null => inMemoryToken

// Request headers for authenticated calls. Adds the Bearer header only when a
// token is actually held — after a page reload the token is gone and the
// HttpOnly session cookie (attached automatically, see httpCredentials.ts)
// authenticates the request instead. Never emit "Bearer null".
export const authHeaders = (extra: Record<string, string> = {}): Record<string, string> => {
  return inMemoryToken ? { ...extra, Authorization: `Bearer ${inMemoryToken}` } : extra
}
